import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'
import Editor from '../../../../components/message/editor'
import { ChartIcon } from '../../../../components/icons'
import { Badge, Modal, message as antdMessage } from 'antd'
import PageLoading from '../../../../components/UI/status/loading'
import { PushpinOutlined, SearchOutlined, TeamOutlined } from '@ant-design/icons'
import { deleteRocketChatMessage, editRocketChatMessage, pinRocketChatMessage, sendChatNotification, sendRocketChatMessage } from '../../../../api'
import { Message } from './message'
import { extractDocumentsFromText } from '../../../../utils'
import amplitude from '../../../../analytics'

export const ChatWindow = ({
    channels, selectedChannel, containerRef, messages, loading, threads, setSelectedThread, clientId, personId,
    isThreadsWindow = null, selectedThread = null, firstUnreadRef, setThreads, threadsRef, ws, currentMessageRef,
    selectedThreadRef, onClickViewAllThreads, receipt, fetchThreadMessages, loadngThreadReplies, onClickViewThread,
    showPinnedMessages, setShowSearchSection, setMessages, onClickShowPinnedMessages, syncThreadsCount, userAvatars,
    selectedMessageId, loadingNext, loadingPrev, userRole, setShowChannelMembers, onClickShowSearchSection
}) => {

    const [editMessageId, setEditMessageId] = useState(null)
    const [users, setUsers] = useState([])

    const threadsContainerRef = useRef(null)

    useEffect(() => {
        if (selectedThread) fetchThreadMessages(selectedThread._id)
    }, [selectedThread])

    useEffect(() => {
        if (!selectedChannel) return
        const currentChannel = channels.filter((channel) => channel._id === selectedChannel)[0]
        setUsers(currentChannel.users || [])
    }, [selectedChannel])

    const onReplyInThread = (msg) => {
        setThreads([])
        threadsRef.current = []
        setSelectedThread(msg)
        selectedThreadRef.current = msg
    }

    const sendMessage = async (msg, selectedThread = null, text) => {
        // if (ws && ws.current && (ws.current.readyState !== WebSocket.OPEN)) {
        //     antdMessage.error('Disconnected. Please refresh the page.')
        //     return
        // }
        try {
            users.forEach((user) => {
                msg = msg.replaceAll(`@${user.name}`, `@${user.username}`)
            })
            currentMessageRef.current = msg
            selectedThreadRef.current = selectedThread
            // ws.send(JSON.stringify({
            //     msg: 'method',
            //     method: 'sendMessage',
            //     id: '42',
            //     params: [{
            //         rid: selectedChannel,
            //         msg: currentMessageRef.current,
            //         tmid: selectedThreadRef.current ? selectedThreadRef.current._id : undefined
            //     }]
            // }))
            const res = await sendRocketChatMessage({
                sender_id: personId,
                room_id: selectedChannel,
                message: currentMessageRef.current,
                tmid: selectedThreadRef.current ? selectedThreadRef.current._id : undefined
            })
            const currentChannel = channels.filter((ch) => ch._id === selectedChannel && ch.t === 'd')[0]
            const channel = channels.filter((ch) => ch._id === selectedChannel)[0]
            const receiver = currentChannel ? currentChannel.usernames.filter((name) => !name.includes(String(personId)))[0] : undefined
            const payload = {
                channel_id: selectedChannel,
                channel_name: currentChannel ? '' : (channel ? channel.name.split('_')[0].charAt(0).toUpperCase() + channel.name.split('_')[0].slice(1) : ''),
                text,
                is_DM: currentChannel ? true : false,
                receiver_id: receiver ? Number(receiver.split('_')[1]) : undefined
            }
            if (selectedThread) {
                payload.thread_id = selectedThread._id
            }
            await sendChatNotification(clientId ? clientId : personId, payload)
            if (!clientId) {
                amplitude.track('Replied to chat', {
                    id: clientId,
                    label: 'Chat interaction'
                })
            }
        } catch (error) {
            console.error('Error sending WebSocket message:', error)
            antdMessage.error('Disconnected. Please refresh the page.')
        }
    }

    const onClickPinMessage = async (msg) => {
        try {
            const response = await pinRocketChatMessage({
                message_id: msg._id,
                person_id: personId
            })
            if (response.success) {
                if (msg.tmid) {
                    const newThreads = threads.map((message) => {
                        if (message._id === msg._id) {
                            return {
                                ...message,
                                pinned: true
                            }
                        }
                        return message
                    })
                    setThreads(newThreads)
                } else {
                    const newMessages = messages.map((message) => {
                        if (message._id === msg._id) {
                            return {
                                ...message,
                                pinned: true
                            }
                        }
                        return message
                    })
                    setMessages(newMessages)
                }
                if (showPinnedMessages) {
                    onClickShowPinnedMessages()
                }
                antdMessage.success('Message pinned successfully!')
            } else {
                antdMessage.error('Failed to pin the message. Please try again.')
            }
        } catch (error) {
            console.error('Error pinning message:', error)
            antdMessage.error('An error occurred while pinning the message.')
        }
    }

    const onDeleteMessage = async (msg) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this message?',
            content: 'This action cannot be undone.',
            okText: 'Yes, Delete',
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    const response = await deleteRocketChatMessage({
                        msgId: msg._id,
                        personId: personId,
                        roomId: selectedChannel
                    })

                    if (response.success) {
                        antdMessage.success('Message deleted successfully!')
                        if (isThreadsWindow) {
                            const filtered = threads.filter((message) => message._id !== msg._id)
                            setThreads(filtered)
                            syncThreadsCount(msg, false)
                        } else {
                            const filtered = messages.filter((message) => message._id !== msg._id)
                            setMessages(filtered)
                        }
                    } else {
                        antdMessage.error('Failed to delete the message. Please try again.')
                    }
                } catch (error) {
                    console.error('Error deleting message:', error)
                    antdMessage.error('An error occurred while deleting the message.')
                }
            },
            onCancel: () => {
                console.log('Deletion canceled')
            }
        })
    }

    const onEditMessage = async (msg, newText) => {
        try {
            // Call the API to edit the message
            users.forEach((user) => {
                newText = newText.replaceAll(`@${user.name}`, ` @${user.username}`)
            })
            setEditMessageId(null)
            const response = await editRocketChatMessage({
                message_id: msg._id,
                room_id: selectedChannel,
                person_id: personId,
                new_text: newText
            })

            if (response.success === true) {
                antdMessage.success('Message edited successfully!')

                if (isThreadsWindow) {
                    // Update the message in the threads
                    const updatedThreads = threads.map((message) =>
                        message._id === msg._id ? { ...message, msg: newText } : message
                    )
                    setThreads(updatedThreads)
                } else {
                    // Update the message in the normal messages
                    const updatedMessages = messages.map((message) =>
                        message._id === msg._id ? { ...message, msg: newText } : message
                    )
                    setMessages(updatedMessages)
                }
            } else {
                antdMessage.error('Failed to edit the message. Please try again.')
            }
        } catch (error) {
            console.error('Error editing message:', error)
            antdMessage.error('An error occurred while editing the message.')
        }
    }

    return (
        <>
            <div className='channel-heding'>
                {isThreadsWindow ? (
                    <>
                        <div>Threads</div>
                        <div className='cursor-pointer' onClick={() => setSelectedThread(null)}>x</div>
                    </>
                ) : (
                    <>
                        <div>
                            {(channels.length > 0 && selectedChannel) ? channels.filter((ch) => ch._id === selectedChannel)[0].name.split('_')[0] : ''}
                        </div>
                        <div className='flex-between'>
                            <div>
                                {
                                users.length > 0 ? (
                                        <TeamOutlined className="cursor-pointer" onClick={() => setShowChannelMembers(true) }/>
                                ) : (<></>)
                            }
                            </div>
                            <div>
                                <SearchOutlined className='cursor-pointer'
                                    onClick={onClickShowSearchSection} />
                            </div>
                            <div>
                                <PushpinOutlined className='cursor-pointer'
                                    onClick={onClickShowPinnedMessages}
                                />
                            </div>
                            <div className='threads-icon'>
                                {receipt['tunread'] && receipt.tunread.length > 0 ? (
                                    <Badge className='count-badge' size='small' count={receipt.tunread.length} />
                                ) : (<></>)}
                                <ChartIcon className='cursor-pointer' onClick={onClickViewAllThreads} />
                            </div>
                        </div>
                    </>
                )}
            </div>
            {loading || (isThreadsWindow && loadngThreadReplies) ? (
                <div className='loadingStyle'>
                    <PageLoading />
                </div>) : (
                <div ref={isThreadsWindow ? threadsContainerRef : containerRef} className="messageStyle">
                    {loadingPrev && <div>Loading...</div>}
                    {messages.map((msg, index) => {
                        let text = msg.msg
                        const { documents, text: cleanedText } = extractDocumentsFromText(text)
                        const isNewFormat = cleanedText !== text
                        text = cleanedText
                        let editMsg = msg.msg
                        if (documents.length === 0 && msg.mentions && msg.mentions.length > 0) users.forEach((mention) => {
                            text = text.replaceAll(`@${mention.username}`,
                                `<span class='mention'>@${mention.name}</span>`
                            )
                            editMsg = editMsg.replaceAll(`@${mention.username}`, `@${mention.name}`)
                        })
                        const user = userAvatars.filter((user) => user.username === msg.u.username)[0]
                        let sender = msg.u.name
                        if (!sender) {
                            const sender_user = users.filter((user) => user._id === msg.u._id)
                            sender = sender_user.length > 0 ? sender_user[0].name : sender
                        }
                        const item = {
                            sender_person: sender || msg.u.username,
                            id: '',
                            created_at: msg.ts,
                            text: text,
                            status: '',
                            is_draft: '',
                            clientId: '',
                            img: user ? user.avatar : '',
                            editMsg
                        }
                        if (msg.u.username === 'Akash_0' && !msg.alias) return <></>
                        return (
                            <Message
                                item={item}
                                msg={msg}
                                onClickViewThread={onClickViewThread}
                                onReplyInThread={onReplyInThread}
                                isThreadsWindow={isThreadsWindow}
                                firstUnreadRef={firstUnreadRef}
                                selectedThread={selectedThread}
                                threads={threads}
                                onClickPinMessage={onClickPinMessage}
                                onDeleteMessage={onDeleteMessage}
                                personId={personId}
                                setEditMessageId={setEditMessageId}
                                editMessageId={editMessageId}
                                onEditMessage={onEditMessage}
                                users={users}
                                selectedMessageId={selectedMessageId}
                                documents={documents}
                                explanation={isNewFormat ? text : undefined}
                                userRole={userRole}
                                previousMessage={index > 0 ? messages[index - 1].msg : ''}
                            />
                        )
                    })}
                    {loadingNext && <div>Loading...</div>}
                </div>)}
            <div className="message-bar" style={{ position: 'relative' }}>
                <Editor
                    loading={false}
                    clientId={clientId ? clientId : personId}
                    onSubmitCallback={(messages, text) => sendMessage(messages, selectedThread, text)}
                    isChatPage={true}
                    users={users}
                />
            </div>
        </>
    )
}
